export default "__VITE_ASSET__B7MTNx3N__"